import React, { createContext, useCallback, useContext, useEffect, useMemo, useReducer } from 'react'

const SAVE = 'SAVE_SEC_TOKENS'

const SecTokenContext = createContext()

function useSecTokenContext() {
  return useContext(SecTokenContext)
}

function reducer(state, { type, payload }) {
  switch (type) {
    case SAVE: {
      const { secTokens } = payload
      const objectSecTokens = secTokens.reduce((accum, item) => {
        const address = item.address?.toLowerCase()
        return {
          ...accum,
          [address]: item,
        }
      }, {})
      return {
        ...state,
        ...objectSecTokens,
      }
    }
    default: {
      throw Error(`Unexpected action type in DataContext reducer: '${type}'.`)
    }
  }
}

export default function Provider({ children }) {
  const [state, dispatch] = useReducer(reducer, {})

  const save = useCallback((secTokens) => {
    dispatch({
      type: SAVE,
      payload: {
        secTokens,
      },
    })
  }, [])

  return (
    <SecTokenContext.Provider
      value={useMemo(
        () => [
          state,
          {
            save,
          },
        ],
        [state, save]
      )}
    >
      {children}
    </SecTokenContext.Provider>
  )
}
export function Updater() {
  return null
}

/**
 * Get list of sec tokens in IXSwap
 */
export function useSecTokensData() {
  const [state] = useSecTokenContext()
  return state || {}
}
